module.exports = __webpack_public_path__ + "static/shequnfuwu.451a18fe.jpg";